exports.linkResolver = (doc) => {
  const formatDate = (isoString) => {
    const date = new Date(isoString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  if (doc.uid !== 'index' && doc.type === 'page') return `/${doc.uid}/`
  if (doc.type === 'event') {
    const formattedDate = formatDate(doc.data?.start_date_and_time)
    return `/events/${formattedDate}/${doc.uid}/`
  }
  if (doc.type === 'room') return `/rooms/${doc.uid}/`
  return `/`
}
